import React from 'react';
import PropTypes from 'prop-types';
import '@assets/css/common/style_modal.css';

const AlertModal = ({ isOpen, message, onClose }) => {
  if (!isOpen) return null;
  
  return (
    <div className="modal-overlay active" id="alert-modal">
      <div className="modal-container">
        <div className="modal-header">
          <h3 className="modal-title">알림</h3>
          <button className="modal-close" onClick={onClose}>&times;</button>
        </div>
        <div className="modal-body">
          <p>{message}</p>
        </div>
        <div className="modal-footer">
          <button 
            className="modal-btn modal-btn-primary"
            onClick={onClose}
          >
            확인
          </button>
        </div>
      </div>
    </div>
  );
};

AlertModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  message: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired
};

export default AlertModal;